module.exports = __webpack_public_path__ + "img/Video.c68f71b6.webp";